import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import appStyles from "../styles/appStyles";
import React from "react";
import { StyleSheet, css } from "aphrodite/no-important";

const styles = StyleSheet.create({
	input: {
		borderTop: "none",
		borderLeft: "none",
		borderRight: "none",
		borderBottom: `solid 1px ${colors.transparent}`,
		outline: 0,
		transition: "border-color 0.3s",
		fontSize: 20,

		":focus": {
			outline: 0,
			borderBottom: `solid 1px ${colors.docketLightGrey22}`,
		},
	},
});

const TextField = ({ aStyles, ...props }) => {
	return <input {...props} className={css(appStyles.baseFont, styles.input, aStyles)} />;
};

TextField.propTypes = {
	aStyles: docketPropTypes.aphroditeStyles,
};

export default TextField;
